import { useEffect, useRef } from "react";
import { useApp } from "@/context/AppCtx";

/**
 * AutoPilot ensures the dashboard tracks an active position on initial load
 * if the user has auto-pilot enabled, but won't hijack the UI afterward.
 */
export function AutoPilot() {
  const { caMintInput, setCaMintInput, autoPilotEnabled } = useApp() as any;
  const hasInitialized = useRef(false);

  useEffect(() => {
    let active = true;

    // Reset initialization if autopilot is disabled so it can trigger again when turned on
    if (!autoPilotEnabled) {
      hasInitialized.current = false;
      return;
    }

    if (hasInitialized.current) return;
    
    // If there's already a mint selected (e.g. from URL or user click), don't override it.
    if (caMintInput) {
      hasInitialized.current = true;
      return;
    }

    // On initial load with AutoPilot on and no mint selected, fetch the top active position
    fetch("/api/server-paper-open-positions")
      .then(res => res.json())
      .then(data => {
        if (!active) return;
        const valid = (Array.isArray(data) ? data : []).filter((p: any) => 
          p && 
          p.mint && 
          !p.isRugged && 
          !p.isDead && 
          p.mint.toLowerCase() !== "dmxgg48pyynprxdbkxvtzs1kzojc6g6efme8jaoypump" &&
          (p.pnlPct == null || p.pnlPct > -0.75)
        );
        if (valid.length > 0) {
          console.log(`[AUTOPILOT] Navigating to top active position: ${valid[0].mint}`);
          setCaMintInput(valid[0].mint);
        }
        hasInitialized.current = true;
      })
      .catch(err => {
        console.warn("[AUTOPILOT] Failed to fetch active positions", err);
        if (active) hasInitialized.current = true;
      });

    return () => { active = false; };
  }, [autoPilotEnabled, caMintInput, setCaMintInput]);

  return null;
}
